<template>
  <div>
    <!-- 搜索 弹层 -->
    <div class="search" v-show="accountLogin.isPullDownHotel">
      <div class="search-input">
        <input
          type="text"
          ref="clearHotelRef"
          placeholder="请搜索/选择门店"
          :value="HotelInputKye"
          v-on:input="searchHotels"
        />
        <span
          class="serch-close"
          v-if="HotelInputKye != ''"
          @click="clearHotel"
        ></span>
      </div>
      <ul class="search-list">
        <li
          v-for="(hotel, i) in Hotels"
          :key="i"
          class="hotel-list-item"
          @click.stop="checkedHotel(hotel)"
        >
          <span>{{ hotel && hotel.HotelCd }}</span>
          {{ hotel && hotel.HotelName }}
        </li>
      </ul>
    </div>
    <div class="home">
      <div class="logo">
        <div class="logo-icon"></div>
        <div class="logo-name">
          <p>Hello！</p>
          <p class="logo-name-text">欢迎登录首旅如家</p>
        </div>
      </div>
      <div class="log-in">
        <!-- 手机验证码登录  -->
        <div v-if="!accountLogin.switch">
          <div
            class="log-in-item"
            :class="formData.cellPhone.phone.err ? 'err' : ''"
          >
            <div class="err" v-show="formData.cellPhone.phone.err">
              <i class="err-icon"></i>
              <span>{{ formData.cellPhone.phone.msg }}</span>
            </div>
            <div
              class="clearInput"
              v-show="formData.cellPhone.phone.close"
              @click="clearInput('inputPhone')"
            ></div>
            <input
              type="number"
              ref="inputPhoneRef"
              autocomplete="off"
              placeholder="请输入您的手机号"
              v-model="formData.cellPhone.phone.text"
              @focus="phoneFouse"
              @input="phoneFouse"
              @blur="phoneBlur"
            />
          </div>
          <div
            class="log-in-item log-in-code"
            :class="formData.cellPhone.mobileCode.err ? 'err' : ''"
          >
            <div class="err" v-show="formData.cellPhone.mobileCode.err">
              <i class="err-icon"></i>
              <span>{{ formData.cellPhone.mobileCode.msg }}</span>
            </div>
            <div
              class="clearInput"
              v-show="formData.cellPhone.mobileCode.close"
              @click="clearInput('inputPhoneCode')"
            ></div>
            <input
              type="text"
              ref="inputPhoneCodeRef"
              placeholder="请输入您的验证码"
              autocomplete="off"
              v-model="formData.cellPhone.mobileCode.code"
              @focus="phoneCodeFouse"
              @input="phoneCodeFouse"
              @blur="phoneCodeBlur"
            />
            <button @click="getMobileCode()">{{ getMobileCodeText() }}</button>
          </div>
        </div>

        <!-- 账号密码登录  -->
        <div v-if="accountLogin.switch">
          <div
            class="log-in-item"
            :class="formData.account.account.err ? 'err' : ''"
          >
            <div class="err" v-show="formData.account.account.err">
              <span v-cloak>{{ formData.account.account.msg }}</span>
              <!-- :href="resetpasswordsurl" -->
              <a
                class="resetpasswordsurl"
                :href="resetpasswordsurl"
                v-show="resetpasswords9"
                @click="resetpasswordsurlClick"
                >立即修改</a
              >
            </div>
            <div
              class="clearInput"
              v-show="formData.account.account.close"
              @click="clearInput('inputName')"
            ></div>
            <input
              type="text"
              ref="inputNameRef"
              autocomplete="off"
              placeholder="请输入您的账号"
              v-focus
              v-model="formData.account.account.text"
              @focus="nameFouse"
              @input="nameFouse"
              @blur="nameBlur"
            />
          </div>
          <div
            class="log-in-item log-in-pwd"
            v-show="!inscriptions"
            :class="formData.account.password.err ? 'err' : ''"
          >
            <div class="err" v-show="formData.account.password.err">
              <i class="err-icon"></i>
              <span>{{ formData.account.password.msg }}</span>
            </div>
            <div
              class="clearInput"
              style="background-color: #fff; top: 0.2rem"
              v-show="formData.account.password.close"
              @click="clearInput('inputPwd')"
            ></div>
            <!-- <i class="log-in-pwd-icon"></i> -->
            <div class="pwdtag-iocn" @click="passwordInscriptions"></div>
            <input
              type="password"
              ref="inputPwdRef"
              autocomplete="new-password"
              placeholder="请输入您的域密码/PMS密码/首旅密码"
              v-model="formData.account.password.code"
              @focus="namePwdFouse"
              @input="namePwdFouse"
              @blur="namePwdBlur"
            />
          </div>
          <div
            class="log-in-item log-in-pwd"
            v-show="inscriptions"
            :class="formData.account.password.err ? 'err' : ''"
          >
            <div class="err" v-show="formData.account.password.err">
              <i class="err-icon"></i>
              <span>{{ formData.account.password.msg }}</span>
            </div>
            <div
              class="clearInput"
              style="background-color: #fff; top: 0.2rem"
              v-show="formData.account.password.close"
              @click="clearInput('inputPwd')"
            ></div>
            <!-- <i class="log-in-pwd-icon"></i> -->
            <div class="proclaimed-iocn" @click="passwordInscriptions"></div>
            <input
              type="text"
              autocomplete="new-password"
              placeholder="请输入您的域密码/PMS密码/首旅密码"
              v-model="formData.account.password.code"
              @focus="namePwdFouse"
              @input="namePwdFouse"
              @blur="namePwdBlur"
            />
          </div>
        </div>

        <div
          class="log-in-item log-in-select"
          @click="onChangePullDown"
          v-show="selectHotel != null"
        >
          <div class="select-hotel">
            <div class="triangle"></div>
          </div>
          <!-- <span class="serch-close"></span> -->
          <input
            type="texe"
            :value="HotelInputKye"
            readonly
            placeholder="请搜索/选择门店"
          />
        </div>
        <button
          class="log-in-serve"
          @click="btnClick()"
          @keyup.enter="btnClick()"
        >
          登录
        </button>
        <!-- <Geet :isGeet="isgt" @geetPath="GeetPath" @clickChange="GeetChange"></Geet> -->
        <component
          :is="currentCom"
          :isGeet="isgt"
          @geetPath="GeetPath"
          @clickChange="GeetChange"
        ></component>
        <div class="log-in-next">
          <a class="log-in-next-item" @click="logInToSwitch">{{
            accountLogin.text
          }}</a>
          <a
            class="log-in-next-item"
            v-if="accountLogin.switch"
            @click="nextPageRegst"
            >忘记密码</a
          >
        </div>
      </div>
      <div class="carousel">
        <p class="carousel-title">品牌展示</p>
        <div class="carousel-warp">
          <homeSwiper></homeSwiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import homeSwiper from "../swiper";
import Geet from "../Geet.vue";
import { isCellPhoneNumber } from "../../common/utils";
export default {
  name: "H5LogIn",
  components: {
    homeSwiper,
    Geet,
  },
  data: function () {
    return {
      currentCom: "",
      resetpasswords9: false,
      resetpasswordsurl: "",
      inscriptions: false, // 密码明文切花
      token: "",
      btnIsGt: false, // 是否显示验证码 在酒店列表接口  isError =true
      isgt: false, // 显示 图形验证
      LoginType: 0,
      UserId: "",
      // 参数类型不需要编码 只有 a标签跳转的需要  Url 跳转 需要编码
      ReturnUrl: "",
      accountLogin: {
        isPullDownHotel: false, // 酒店列表
        switch: true, // 登录方式
        text: "验证码登录",
      },
      formData: {
        // 登录 验证
        account: {
          account: {
            text: "",
            close: false,
            err: false,
            msg: "请输入您的账号",
          },
          password: {
            code: "",
            close: false,
            err: false,
            msg: "请输入域密码/PMS密码/首旅密码",
          },
        },
        cellPhone: {
          phone: {
            text: "",
            close: false,
            err: false,
            msg: "请输入您的手机号",
          },
          mobileCode: {
            code: "",
            close: false,
            err: false,
            msg: "请输入短信验证码",
          },
          wait_timer: false,
        },
      },
      timer_interval: null,
      timer_timeout: null,
      HotelInputKye: "",
      selectHotel: null,
      seldectHoteBackups: null, // 酒店拷贝
      Hotels: [], // 酒店列表
      isHotels: false, // 是否加载过酒店列表的方法
    };
  },
  methods: {
    // 首次 登陆必须修改密码
    resetpasswordsurlClick: function () {
      window.href = this.resetpasswordsurl;
    },
    // 密码明文切换
    passwordInscriptions: function () {
      this.inscriptions = !this.inscriptions;
    },
    // 清除 input 框
    clearInput: function (type) {
      if (type === "inputName") {
        this.formData.account.account.text = "";
      }
      if (type === "inputPwd") {
        this.formData.account.password.code = "";
      }
      if (type === "inputPhone") {
        this.formData.cellPhone.phone.text = "";
      }
      if (type === "inputPhoneCode") {
        this.formData.cellPhone.mobileCode.code = "";
      }
      this.$nextTick(() => {
        if (type === "inputName") {
          this.$refs.inputNameRef.focus();
        }
        if (type === "inputPwd") {
          this.$refs.inputPwdRef.focus();
        }
        if (type === "inputPhone") {
          this.$refs.inputPhoneRef.focus();
        }
        if (type === "inputPhoneCode") {
          this.$refs.inputPhoneCodeRef.focus();
        }
      });
    },
    nextPageRegst: function () {
      window.location = `/AccountLogin/ForgetPass?ReturnUrl=${encodeURIComponent(
        this.ReturnUrl
      )}`;
    },
    /**
     * 登录方式切换
     */
    logInToSwitch: function (e) {
      e.stopPropagation();
      this.formData.account.account.err = false;
      this.formData.cellPhone.phone.err = false;
      this.accountLogin.switch = !this.accountLogin.switch;
      if (this.accountLogin.switch) {
        this.accountLogin.text = "验证码登录";
        this.getHotelListFn(1);
      } else {
        this.formData.cellPhone.mobileCode.code = "";
        this.formData.cellPhone.phone.text = "";
        this.accountLogin.text = "账号密码登录";
        this.getHotelListFn(2);
      }
    },
    /**
     * 极验图片加载之后，通过更改控制变量实现可以再次加载
     */
    GeetChange: function (val) {
      this.isgt = val;
    },

    GeetPath: function (val) {
      this.isgt = false;
      this.logonfn(val);
    },
    /**
     *  取消用户名 错误提示
     */
    nameFouse: function () {
      this.formData.account.account.err = false;
      const name = this.formData.account.account.text;
      if (!name) {
        this.formData.account.account.close = false;
      } else {
        this.formData.account.account.close = true;
      }
      // this.formData.account.account.err = false;
    },
    /**
     * 用户名失去焦点 是否价值酒店列表
     */
    nameBlur: function () {
      const _self = this;
      const name = this.formData.account.account.text;
      _self.$nextTick(function () {
        setTimeout(function () {
          _self.formData.account.account.close = false;
        }, 200);
      });
      if (name === "") {
        this.formData.account.account.err = true;
        this.formData.account.account.msg = "请输入您的账号";
        return;
      }
      this.formData.account.account.err = false;
      this.formData.account.account.msg = "";
      clearTimeout(_self.timer_timeout);
      _self.timer_timeout = null;
      _self.timer_timeout = setTimeout(function () {
        _self.getHotelListFn(1);
        _self.timer_timeout = null;
      }, 500);
    },
    /**
     *  用户名登录是否输入密码
     */
    namePwdFouse: function () {
      const namePwd = this.formData.account.password.code;
      this.formData.account.password.err = false;
      if (!namePwd) {
        this.formData.account.password.close = false;
      } else {
        this.formData.account.password.close = true;
      }
      // this.formData.account.account.err = false;
    },
    /**
     * 用户名失去密码焦点
     */
    namePwdBlur: function () {
      const _self = this;
      const name = this.formData.account.account.text;
      const pwd = this.formData.account.password.code;
      _self.$nextTick(function () {
        setTimeout(function () {
          _self.formData.account.password.close = false;
        }, 200);
      });
      if (name === "") {
        this.formData.account.account.err = true;
        this.formData.account.account.msg = "请输入您的账号";
        return;
      }
      if (pwd === "") {
        this.formData.account.password.err = true;
        this.formData.account.password.msg = "请输入域密码/PMS密码/首旅密码";
        return;
      }
      this.formData.account.password.err = false;
      this.formData.account.password.msg = "";
    },
    /**
     *  取消手机验错误提示
     */
    phoneFouse: function () {
      const phone = this.formData.cellPhone.phone.text;
      this.formData.cellPhone.phone.err = false;
      if (!phone) {
        this.formData.cellPhone.phone.close = false;
      } else {
        this.formData.cellPhone.phone.close = true;
      }
    },
    /**
     * 手机号失去焦点 是否价值酒店列表
     */
    phoneBlur: async function () {
      const _self = this;
      const phone = this.formData.cellPhone.phone.text;
      _self.$nextTick(function () {
        setTimeout(function () {
          _self.formData.cellPhone.phone.close = false;
        }, 200);
      });
      if (phone === "") {
        this.formData.cellPhone.phone.err = true;
        this.formData.cellPhone.phone.msg = "请输入您的手机号";
        return;
      }
      const isPhone = await isCellPhoneNumber(phone);
      if (isPhone) {
        this.formData.cellPhone.phone.err = true;
        this.formData.cellPhone.phone.msg = "请输入正确的手机号";
        return;
      }
      this.formData.cellPhone.phone.err = false;
      this.formData.cellPhone.phone.msg = "";
      // clearTimeout(_self.timer_timeout);
      // _self.timer_timeout = null;
      // _self.timer_timeout = setTimeout(function () {
      //   _self.getHotelListFn(2);
      //   clearTimeout(_self.timer_timeout);
      //   _self.timer_timeout = null;
      // }, 500);
    },
    /**
     *  取消验证码误提示
     */
    phoneCodeFouse: function () {
      const code = this.formData.cellPhone.mobileCode.code;
      this.formData.cellPhone.mobileCode.err = false;
      if (!code) {
        this.formData.cellPhone.mobileCode.close = false;
      } else {
        this.formData.cellPhone.mobileCode.close = true;
      }
      // this.formData.account.account.err = false;
    },
    /**
     * 酒店列表
     */
    onChangePullDown: function () {
      if (this.Hotels.length > 0) {
        this.accountLogin.isPullDownHotel = !this.accountLogin.isPullDownHotel;
      }
    },
    /**
     * 验证码失去焦点 是否价值酒店列表
     */
    phoneCodeBlur: async function () {
      const _self = this;
      const code = _self.formData.cellPhone.mobileCode.code;
      const phone = _self.formData.cellPhone.phone.text;
      _self.$nextTick(function () {
        setTimeout(function () {
          _self.formData.cellPhone.mobileCode.close = false;
        }, 200);
      });
      if (phone === "") {
        _self.formData.cellPhone.phone.err = true;
        _self.formData.cellPhone.phone.msg = "请输入您的手机号";
        return;
      }
      const isPhone = await isCellPhoneNumber(phone);
      if (isPhone) {
        _self.formData.cellPhone.phone.err = true;
        _self.formData.cellPhone.phone.msg = "请输入正确的手机号";
        return;
      }
      if (code === "") {
        _self.formData.cellPhone.mobileCode.err = true;
        _self.formData.cellPhone.mobileCode.msg = "请输入短信验证码";
        return;
      }

      _self.formData.cellPhone.mobileCode.err = false;
      _self.formData.cellPhone.mobileCode.msg = "";
    },
    /**
     * 验证码是否酒店列表
     */
    getMobileCode: async function () {
      const _self = this;
      const phone = _self.formData.cellPhone.phone.text;
      if (_self.formData.cellPhone.wait_timer > 0) {
        return false;
      }
      if (phone === "") {
        _self.formData.cellPhone.phone.err = true;
        _self.formData.cellPhone.phone.msg = "请输入您的手机号";
        return;
      }
      const isPhone = await isCellPhoneNumber(phone);
      if (isPhone) {
        _self.formData.cellPhone.phone.err = true;
        _self.formData.cellPhone.phone.msg = "请输入正确的手机号";
        return;
      }

      const params = {
        Mobile: phone,
        type: 6,
      };

      const phoneKey = await _self.$http.getPhoneSendKey(params);
      const getPhoneCode = Number(phoneKey.Code);
      if (getPhoneCode !== 200) {
        _self.formData.cellPhone.phone.err = true;
        _self.formData.cellPhone.phone.msg = phoneKey.Msg;
        return false;
      }
      clearTimeout(_self.timer_timeout);
      _self.timer_timeout = null;
      _self.timer_timeout = setTimeout(function () {
        _self.getHotelListFn(2);
        clearTimeout(_self.timer_timeout);
        _self.timer_timeout = null;
      }, 500);
      _self.formData.cellPhone.wait_timer = 59;
      _self.timer_interval = setInterval(function () {
        if (_self.formData.cellPhone.wait_timer > 0) {
          _self.formData.cellPhone.wait_timer--;
        } else if (_self.formData.cellPhone.wait_timer <= 0) {
          clearInterval(_self.timer_interval);
          _self.timer_interval = null;
        }
      }, 1000);
    },
    /**
     * 点击获取图新验证
     */
    /**
     * 选择酒店
     */
    checkedHotel: function (item) {
      this.selectHotel = item;
      this.HotelInputKye = `${item.HotelCd}  ${item.HotelName}`;
      this.accountLogin.isPullDownHotel = !this.accountLogin.isPullDownHotel;
    },
    /**
     * 搜索酒店
     */
    searchHotels: function (e) {
      const _self = this;
      _self.accountLogin.isPullDownHotel = true;
      if (_self.HotelInputKye === e.target.value) return;
      _self.HotelInputKye = e.target.value;
      if (_self.selectHotel === null) {
        return;
      }
      if (_self.HotelInputKye.trim() === "") {
        return [];
      }
      const inputKey = _self.HotelInputKye.toUpperCase();
      const hotels = _self.seldectHoteBackups.filter(function (item) {
        return item.HotelCd.indexOf(inputKey) !== -1;
      });
      _self.Hotels = hotels;
    },
    /**
     * 请空搜索字段
     */
    clearHotel: function () {
      const _self = this;
      _self.HotelInputKye = "";
      _self.Hotels = _self.seldectHoteBackups;
      _self.$nextTick(() => {
        _self.$refs.clearHotelRef.focus();
        _self.Hotels = _self.seldectHoteBackups;
      });
    },
    btnClick: async function () {
      const _self = this;
      if (_self.accountLogin.switch) {
        const name = _self.formData.account.account.text;
        const pwd = _self.formData.account.password.code;
        if (name === "") {
          _self.formData.account.account.err = true;
          _self.formData.account.account.msg = "请输入您的账号";
          return;
        }
        if (pwd === "") {
          _self.formData.account.password.err = true;
          _self.formData.account.password.msg = "请输入域密码/PMS密码/首旅密码";
          return;
        }
      } else if (!_self.accountLogin.switch) {
        const phone = _self.formData.cellPhone.phone.text.trim();
        const code = _self.formData.cellPhone.mobileCode.code.trim();

        if (phone === "") {
          _self.formData.cellPhone.phone.err = true;
          _self.formData.cellPhone.phone.msg = "请输入您的手机号";
          return;
        }
        const isPhone = await isCellPhoneNumber(phone);
        if (isPhone) {
          _self.formData.cellPhone.phone.err = true;
          _self.formData.cellPhone.phone.msg = "请输入正确的手机号";
          return;
        }
        if (code === "") {
          _self.formData.cellPhone.mobileCode.err = true;
          _self.formData.cellPhone.mobileCode.msg = "请输入您的验证码";
          return;
        }
      }
      // 如果有缓存数据
      if (!_self.isHotels) {
        _self.getHotelListFn(1);
        return;
      }
      if (_self.btnIsGt) {
        _self.isgt = !_self.isgt;
      } else {
        _self.logonfn();
      }
    },
    // 登录
    logonfn: async function (val) {
      const _self = this;
      let geetest = null;
      let name = {
        UserId: "",
        Pwd: "",
        LoginType: "pwd",
      };
      const pmHotelCd =
        _self.selectHotel !== null ? _self.selectHotel.HotelCd : "";
      const pmHotelname =
        _self.selectHotel !== null && _self.selectHotel.length > 0
          ? `${_self.selectHotel.HotelCd}  ${_self.selectHotel.HotelName}`
          : "";

      const params = {
        __RequestVerificationToken: _self.token,
        ReturnUrl: _self.ReturnUrl,
        HotelCd: pmHotelCd,
        hotelname: pmHotelname,
      };
      if (_self.accountLogin.switch) {
        name = {
          UserId: _self.formData.account.account.text.trim(),
          Pwd: _self.formData.account.password.code.trim(),
          LoginType: "pwd",
        };
        if (name.UserId === "" || name.Pwd === "") {
          return false;
        }
      } else {
        name = {
          Mobile: _self.formData.cellPhone.phone.text.trim(),
          Pwd: _self.formData.cellPhone.mobileCode.code.trim(),
          LoginType: "sms",
        };
        if (name.Mobile === "" || name.Pwd === "") {
          return false;
        }
      }
      if (val) {
        geetest = {
          geetest_challenge: val.geetest_challenge,
          geetest_seccode: val.geetest_seccode,
          geetest_validate: val.geetest_validate,
        };
        Object.assign(params, geetest);
      }
      Object.assign(params, name);

      // const paramsFormData = new FormData();
      // Object.keys(params).forEach(key => {
      //   paramsFormData.append(key, params[key]);
      // });
      const login = await _self.$http.postLogin(params);
      const loginCode = Number(login.Code);
      const loginMemo = Number(login.Memo);
      // 是否需要验证码
      if (loginMemo === -1) {
        _self.currentCom = Geet;
        _self.btnIsGt = true;
      }
      if (loginCode === 301) {
        const _url = `${login.Data.UpdatePwdUrl}`;
        _self.resetpasswords9 = true;
        _self.resetpasswordsurl = _url;
        _self.formData.account.account.msg = login.Msg;
        _self.formData.account.account.err = true;
        return false;
      }

      if (loginCode === 200) {
        window.location.replace(login.Data.LoginSuccessReturnUrl);
      } else {
        // this.loginErrorNumber = this.loginErrorNumber + 1;
        if (name.LoginType === "pwd") {
          _self.formData.account.account.msg = login.Msg;
          _self.formData.account.account.err = true;
          _self.resetpasswords9 = false;
        } else if (name.LoginType === "sms") {
          _self.formData.cellPhone.phone.err = true;
          _self.formData.cellPhone.phone.msg = login.Msg;
        }
      }
    },
    getMobileCodeText: function () {
      if (this.formData.cellPhone.wait_timer > 0) {
        return this.formData.cellPhone.wait_timer + "s";
      }
      if (this.formData.cellPhone.wait_timer === false) {
        return "获取验证码";
      }
      if (this.formData.cellPhone.wait_timer === 0) {
        return "重新获取";
      }
    },
    /**
        酒店列表  type=1:用户名 2: 手机号
         */
    getHotelListFn: async function (type) {
      const _self = this;
      this.HotelInputKye = "";
      this.selectHotel = null;
      this.seldectHoteBackups = null;
      this.Hotels = [];
      const name = this.formData.account.account.text.trim();
      let params = {
        UserId: name.trim(),
        LoginType: "pwd",
      };
      if (type === 1 && name === "") {
        return;
      }
      if (type === 2) {
        const phone = this.formData.cellPhone.phone.text.trim();
        if (phone === "") {
          return;
        }
        params = {
          Mobile: phone,
          LoginType: "sms",
        };
      }
      _self.isHotels = true;
      const resHotels = await _self.$http.getTheHotelList(params);
      const resultCode = Number(resHotels.Code);
      const resultMemo = Number(resHotels.Memo); // 判断用户密码是否已经过期

      // 是否需要验证码
      if (resultMemo === -1) {
        this.currentCom = Geet;
        _self.btnIsGt = true;
      }

      if (resultCode === 200) {
        if (
          resHotels.Data &&
          resHotels.Data.Hotels &&
          resHotels.Data.Hotels.length > 0
        ) {
          _self.Hotels = resHotels.Data.Hotels;
          _self.seldectHoteBackups = resHotels.Data.Hotels;
          // this.seldectHoteBackups = this._.clone(this.Hotels, true);
          _self.selectHotel = resHotels.Data.Hotels[0];
          _self.HotelInputKye = `${_self.selectHotel.HotelCd}  ${_self.selectHotel.HotelName}`;
        } else {
          _self.selectHotel = null;
        }
        if (resultMemo >= 76 && resultMemo < 90) {
          // 密码 14-4 天之间过期提醒
          const overdueCount = 90 - resultMemo;
          // _self.formData.account.password.err = true;
          // _self.formData.account.password.msg = `您的密码还有 ${overdueCount} 天即将过期`;

          const _url = `/AccountLogin/ForgetPass?ReturnUrl=${encodeURIComponent(
            _self.ReturnUrl
          )}`;
          _self.resetpasswordsurl = _url;
          _self.formData.account.account.msg = `您的密码还有 ${overdueCount} 天即将过期`;
          _self.formData.account.account.err = true;
          _self.resetpasswords9 = true;
        } else if (resultMemo >= 90) {
          // 您的密码已经过期，请立即
          const _url = `/AccountLogin/ForgetPass?ReturnUrl=${encodeURIComponent(
            _self.ReturnUrl
          )}`;
          _self.resetpasswordsurl = _url;
          _self.formData.account.account.msg = `您的密码已经过期，请立即修改`;
          _self.formData.account.account.err = true;
          _self.resetpasswords9 = true;
          // _self.formData.account.password.err = true;
          // _self.formData.account.password.msg = `您的密码已经过期，请立即修改`;
        }
      } else {
        if (type === 2) {
          _self.resetpasswords9 = false;
          _self.formData.account.account.err = false;
          _self.formData.cellPhone.phone.err = true;
          _self.formData.cellPhone.phone.msg = resHotels.Msg;
          clearInterval(_self.timer_interval);
          _self.formData.cellPhone.wait_timer = 0;
        } else {
          _self.resetpasswords9 = false;
          _self.formData.cellPhone.phone.err = false;
          _self.formData.account.account.msg = resHotels.Msg;
          _self.formData.account.account.err = true;
        }
      }
    },
  },
  created() {
    // 有参数 微信扫码回调
    this.$nextTick(function () {
      const token = document.getElementsByName("__RequestVerificationToken")[0].value;
      const UserId = document.getElementById("hidUserId").value;
      const OpenId = document.getElementById("hidOpenId").value;
      const code = document.getElementById("hidCode").value;
      const ReturnUrl = document.getElementById("hidReturnUrl").value;
      const LoginType = document.getElementById("hidLoginType").value;
      const sessionReturn = sessionStorage.getItem("_returnurl");
      // 微信扫码登陆时 returnurl 为空 获取 sessionStroe 里的 returnurl
      this.token = token;
      const catchReturnUrl = ReturnUrl === "" ? sessionReturn : ReturnUrl;

      this.LoginType = LoginType;
      this.UserId = UserId;
      this.OpenId = OpenId;
      this.Code = code;
      // 参数类型不需要编码 只有 a标签跳转的需要  Url 跳转 需要编码
      this.ReturnUrl = catchReturnUrl;
      if (ReturnUrl !== "") {
        window.sessionStorage.setItem("_returnurl", ReturnUrl);
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@css/style.scss";

[v-cloak] {
  display: none;
}

.home {
  min-height: 100vh;
  background: url("../../assets/img/mobile/login-bg.png") no-repeat top right;
  background-size: 100% auto;
  box-sizing: border-box;
  padding: px2rem(90) px2rem(56) px2rem(30);

  .logo {
    display: flex;
    justify-content: center;
    align-self: start;

    .logo-icon {
      margin-right: px2rem(20);
      width: px2rem(90);
      height: px2rem(103);
      background: url("../../assets/img/mobile/logo-icon.png") no-repeat bottom
        right;
      background-size: 100% auto;
    }

    .logo-name {
      flex-grow: 1;
      // height: px2rem(28);
      border-left: 1px solid rgba(232, 232, 232, 0.6);
      font-size: px2rem(36);
      padding-left: px2rem(22);
      font-weight: bold;
      color: rgba(41, 44, 56, 1);

      .logo-name-text {
        height: px2rem(46);
        font-size: px2rem(48);
        font-weight: bold;
        color: rgba(41, 44, 56, 1);
      }
    }
  }

  .log-in {
    margin-top: px2rem(120);

    .log-in-item {
      position: relative;
      height: px2rem(106);
      padding-top: px2rem(6);
      line-height: px2rem(100);
      border-bottom: 0.5px solid rgba(232, 232, 232, 1);
      display: flex;

      &.err {
        border-bottom: 0.5px solid #ff4444;
        // input {
        //   border-bottom: 0.5px solid #ff4444;
        // }
      }

      .err {
        padding-left: px2rem(18);
        position: absolute;
        left: 0;
        bottom: px2rem(-35);
        // top:px2rem(110);
        height: px2rem(23);
        line-height: px2rem(23);
        font-size: px2rem(24);
        font-weight: 500;
        color: rgba(235, 72, 63, 1);
      }

      input {
        box-sizing: border-box;
        line-height: px2rem(50);
        width: 100%;
        background-color: rgba(0, 0, 0, 0);
        font-size: px2rem(32);
        // border-bottom: 0.5px solid rgba(232, 232, 232, 1);
      }

      // input:focus {
      //   border-color: #5c98ff;
      //   outline: 0;
      //   // box-shadow: 0 0 0 2px rgba(51, 126, 255, 0.2);
      //   // border-right-width: 1px !important;
      // }
      input:-internal-autofill-selected {
        background-color: rgba(0, 0, 0, 0) !important;
      }

      .select-hotel {
        position: absolute;
        top: 0;
        right: 0;
        width: px2rem(75);
        height: px2rem(100);
        padding-top: px2rem(20);
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .serch-close {
        width: px2rem(50);
        height: px2rem(50);
        position: absolute;
        top: px2rem(35);
        right: px2rem(80);
        background: url("../../assets/img/mobile/colse.png") no-repeat center
          center;
        background-size: px2rem(27) px2rem(27);
      }
    }

    .log-in-pwd {
      .clearInput {
        right: px2rem(60);
      }

      position: relative;

      input {
        padding-right: px2rem(100);
      }

      // .log-in-pwd-icon {
      //   position: absolute;
      //   right: px2rem(15);
      //   top: px2rem(60);
      //   width: px2rem(41);
      //   height: px2rem(15);
      //   background: url("../../assets/img/mobile/pwd-icon.png") no-repeat center
      //     center;
      //   background-size: px2rem(41) px2rem(15);
      // }
    }

    .log-in-select {
      input {
        box-sizing: border-box;
        padding-right: px2rem(150);
      }
    }

    .log-in-serve {
      width: 100%;
      height: px2rem(88);
      margin-top: px2rem(55);
      margin-bottom: px2rem(39);
      background: rgba(234, 55, 69, 1);
      box-shadow: 0px 8px 24px 0px rgba(234, 57, 68, 0.2);
      border-radius: px2rem(44);
      font-size: px2rem(32);
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }

    .log-in-next {
      display: flex;
      justify-content: space-between;

      .log-in-next-item {
        position: relative;
        z-index: 100;
        text-decoration: none;
        height: px2rem(25);
        font-size: px2rem(26);
        font-weight: 500;
        color: rgba(121, 135, 146, 1);
        line-height: px2rem(24);
      }
    }

    .log-in-code {
      display: flex;
      justify-content: space-between;

      input {
        flex-grow: 1;
      }

      button {
        min-width: px2rem(200);
        padding: 0 px2rem(10);
        font-size: px2rem(26);
        line-height: px2rem(100);
        font-weight: bold;
        color: rgba(234, 55, 69, 1);
      }
    }
  }

  .carousel {
    margin-top: px2rem(220);

    .carousel-title {
      font-size: px2rem(28);
      font-weight: 400;
      color: rgba(201, 195, 191, 1);
      line-height: px2rem(46);
      text-align: center;
    }
  }
}

.search {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 1000;
  box-sizing: border-box;
  padding-top: px2rem(100);

  .search-input {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: px2rem(100);
    padding: 0 px2rem(54);
    background: #fff;
    box-sizing: border-box;
    z-index: 1000;

    input {
      box-sizing: border-box;
      width: 100%;
      padding: 0 px2rem(50);
      line-height: px2rem(80);
      font-size: px2rem(30);
      border-radius: px2rem(100);
      border: 0.5px solid rgba(232, 232, 232, 1);
    }

    .serch-close {
      width: px2rem(50);
      height: px2rem(80);
      position: absolute;
      top: px2rem(18);
      right: px2rem(70);
      background: url("../../assets/img/mobile/colse.png") no-repeat center
        center;
      background-size: px2rem(27) px2rem(27);
    }
  }

  .search-list {
    z-index: 999;
    padding: px2rem(120) px2rem(54) px2rem(54);
    box-sizing: border-box;
    overflow-y: scroll;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    li {
      line-height: px2rem(77);
      font-size: px2rem(30);
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      border-bottom: 0.5px solid rgba(232, 232, 232, 1);
      text-indent: 1em;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.triangle {
  width: 0px;
  height: 0px;
  border-width: px2rem(12);
  border-style: solid;
  border-color: rgba(187, 187, 187, 1) transparent transparent transparent;
}

.carousel-warp {
  position: relative;
}

input:-internal-autofill-selected {
  background-color: #fff !important;
  background-image: none !important;
  color: -internal-light-dark-color(black, white) !important;
}

.log-in-code .clearInput {
  right: px2rem(190);
  top: px2rem(20);
}

.clearInput {
  position: absolute;
  top: px2rem(30);
  right: 0;
  width: px2rem(60);
  height: px2rem(90);
  background: url("../../assets/img/icons/clearInput.png") no-repeat center
    center;
  background-size: px2rem(28);
  cursor: pointer;
  z-index: 100;
}

.pwdtag-iocn {
  position: absolute;
  right: 0;
  top: px2rem(45);
  width: px2rem(60);
  height: px2rem(30);
  background: url("../../assets/img/mobile/pwd-icon.png") no-repeat center
    center;
  background-size: px2rem(41) px2rem(15);
}

.proclaimed-iocn {
  position: absolute;
  right: 0;
  top: px2rem(45);
  width: px2rem(60);
  height: px2rem(30);
  background: url("../../assets/img/mobile/proclaimed.png") no-repeat center
    center;
  background-size: px2rem(41) px2rem(27);
}

.resetpasswordsurl {
  position: relative;
  z-index: 1000;
}
</style>
